module.exports = __webpack_public_path__ + "img/2019091800.cea18973.jpg";